"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const SharesInfo = (props) => {
    const totalKnownShares = props.totalShares ? Math.round(props.totalShares * 100) / 100 : 0;
    const myShares = props.myShares ? Math.round(props.myShares * 100) / 100 : 0;
    return (react_1.default.createElement("div", { className: 'shares-info' },
        (props.myShares || props.myShares === 0) && (react_1.default.createElement("div", null,
            "My shares: ",
            react_1.default.createElement("span", null,
                myShares,
                "%"))),
        (props.totalShares || props.totalShares === 0) && (react_1.default.createElement("div", null,
            "Total shares: ",
            react_1.default.createElement("span", null,
                totalKnownShares,
                "%")))));
};
exports.default = SharesInfo;
